import { render, staticRenderFns } from "./youtube-input.vue?vue&type=template&id=ec50f506&scoped=true&"
import script from "./youtube-input.vue?vue&type=script&lang=js&"
export * from "./youtube-input.vue?vue&type=script&lang=js&"
import style0 from "./youtube-input.vue?vue&type=style&index=0&id=ec50f506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec50f506",
  null
  
)

export default component.exports